import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class UnknownQuoteErrorException extends QuoteException {

}